import Select from 'react-select';
import styled from '@emotion/styled';
import { Icon } from '@gumtree/ui-library';
import {
    fontSizes,
    lineHeights,
    gutterSizes,
    colorVariables,
    colors,
} from '@gumtree/ui-library/src/base/theme';

export const StyledValueContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    grid-gap: ${gutterSizes.small};
`;

export const StyledText = styled.div`
    font-size: ${fontSizes.small};
    line-height: ${lineHeights.small};
`;

export const StyledOptionContainer = styled.div`
    position: relative;
`;

export const StyledOptionLabel = styled.div`
    display: flex;
`;

export const StyledAbundanceContainer = styled.span`
    padding-left: ${gutterSizes.small};
    color: ${colorVariables.textSecondary};
`;

export const StyledIcon = styled(Icon)`
    position: absolute;
    top: ${gutterSizes.medium10};
    left: ${gutterSizes.small};
    transform: scale(0.7);
`;

export const StyledSelect = styled(Select)`
    padding: 3px;
    &:focus-within {
        outline: 2px solid ${colors.gtallBlue};
    }

    .react-select__indicator-separator {
        display: none;
    }

    .react-select__control {
        border-color: ${colors.bark40};
        box-shadow: none;

        &:hover {
            border-color: ${colorVariables.textLight};
        }
    }

    .react-select__menu {
        border-radius: ${gutterSizes.large};
        overflow: hidden;
    }

    .react-select__menu-list {
        background-color: #f5f4f5;
        padding: 0;
        border-radius: ${gutterSizes.large};
    }

    .react-select__option {
        padding-left: ${gutterSizes.xlarge};
        border-bottom: 1px solid ${colorVariables.borderLight};
    }

    .react-select__option--is-focused {
        cursor: pointer;
        background-color: ${colors.bark10};
    }

    .react-select__option--is-selected {
        background-color: transparent;
        color: inherit;
    }

    .react-select__indicator {
        color: ${colors.bark80};
    }

    .react-select__single-value {
        color: ${colorVariables.mainSecondary};
    }

    .react-select__control--is-disabled {
        background-color: transparent;
        opacity: 0.5;
    }

    .react-select__single-value--is-disabled {
        color: ${colorVariables.mainSecondary};
    }
`;
